import React, { useCallback } from 'react';

import { Button } from '../../Button';
import { IconArrowLeft, IconArrowRight } from '../../../icons';
import { cn } from '../../../lib/css/className/className';
import './OverlayButtons.css';
import type { SliderArrowButtonsProps } from '../types';

const cls = cn('GalleryOverlayButtons');

export type OverlayButtonsProps = SliderArrowButtonsProps & {
    /** Скрывает левую кнопку */
    isHiddenBackward: boolean;
    /** Скрывает правую кнопку */
    isHiddenForward: boolean;
    /** Обработчик клика по левой кнопке */
    onClickBackward: () => void;
    /** Обработчик клика по правой кнопке */
    onClickForward: () => void;
};

export const OverlayButtons = function OverlayButtons({
    className,
    isHiddenBackward,
    isHiddenForward,
    color = 'contrast',
    size = 'm',
    onClick,
    onClickBackward,
    onClickForward,
}: OverlayButtonsProps) {
    const handleClickBackward = useCallback(() => {
        onClickBackward();
        onClick?.('backward');
    }, [onClick, onClickBackward]);

    const handleClickForward = useCallback(() => {
        onClickForward();
        onClick?.('forward');
    }, [onClick, onClickForward]);

    return (
        <>
            {!isHiddenBackward && (
                <Button
                    color={color}
                    icon={IconArrowLeft}
                    size={size}
                    onClick={handleClickBackward}
                    className={cls('buttonBackward', [className])}
                    data-testid="OverlayButtons.Backward"
                />
            )}
            {/* Кнопка 'Вперед' */}
            {!isHiddenForward && (
                <Button
                    color={color}
                    icon={IconArrowRight}
                    size={size}
                    onClick={handleClickForward}
                    className={cls('buttonForward', [className])}
                    data-testid="OverlayButtons.Forward"
                />
            )}
        </>
    );
};
